var { initIframePrint } = require('./shared/iframe-print');

(function () {
    /**
     * Initialize the travel budget calculator
     */
    function init() {
        initIframePrint({
            formId: 'tbcPrintForm',
            iframeId: 'tbcPrintFrame',
            buttonId: 'tbcPrintBtn',
            readyLabel: '<i class="bi bi-printer me-2" aria-hidden="true"></i>Print Budget',
        });

        var loadSampleBtn = document.getElementById('tbcLoadSampleBtn');
        if (loadSampleBtn) {
            loadSampleBtn.addEventListener('click', loadSampleData);
        }

        scrollToResults();
    }

    /**
     * Scroll to the results section if it exists on the page
     */
    function scrollToResults() {
        var results = document.getElementById('budget-results');
        if (results) {
            results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    /**
     * Load sample travel budget data into the form
     */
    function loadSampleData() {
        var fields = {
            'Input_Destination': 'Paris, France',
            'Input_NumberOfDays': '7',
            'Input_NumberOfTravelers': '2',
            'Input_AccommodationPerNight': '180',
            'Input_NumberOfRooms': '1',
            'Input_FlightCost': '1200',
            'Input_CarRentalCost': '0',
            'Input_LocalTransportPerDay': '15',
            'Input_BreakfastPerDay': '12',
            'Input_LunchPerDay': '18',
            'Input_DinnerPerDay': '35',
            'Input_ActivitiesPerDay': '40',
            'Input_ShoppingBudget': '200',
            'Input_TravelInsurance': '85',
            'Input_VisaFees': '0',
            'Input_Miscellaneous': '100',
            'Input_EmergencyFundPercent': '10'
        };

        for (var id in fields) {
            var el = document.getElementById(id);
            if (el) {
                el.value = fields[id];
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
